const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};



// 20250126ヘッダー固定
document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".pointfix-box");
  const sectionOffset = section.offsetTop; // セクションの初期位置を取得

  window.addEventListener("scroll", function () {
    if (window.scrollY > sectionOffset) {
      section.classList.add("h-fixed"); // クラスを追加
    } else {
      section.classList.remove("h-fixed"); // クラスを削除
    }
  });
});

// 20260126 SP電話タップ
document.addEventListener("DOMContentLoaded", function() {
    var device = navigator.userAgent;
    if ((device.indexOf('iPhone') > 0 && device.indexOf('iPad') === -1) || device.indexOf('iPod') > 0 || device.indexOf('Android') > 0) {
        var telLinks = document.querySelectorAll(".sp-tel-link");
        telLinks.forEach(function(link) {
            var wrapper = document.createElement("a");
            wrapper.href = "tel:0120010660";
            link.parentNode.insertBefore(wrapper, link);
            wrapper.appendChild(link);
        });
    }
});